import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import hocScrollbar from 'gnos-scrollbar'

import Tab from './components/Tab'

import hocConnect from './hocConnect'

import './style.scss'

@hocScrollbar({ smoothScrollbar: true, horizontal: true, overscroll: false })
@hocConnect
export default class TabsWrap extends Component {
    static propTypes = {
        activeIndex: PropTypes.number.isRequired,
        activeTab: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        inline: PropTypes.bool.isRequired,
        level: PropTypes.string.isRequired,
        tabs: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                title: PropTypes.string.isRequired,
                subtitle: PropTypes.string,
                content: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
                counter: PropTypes.shape({
                    left: PropTypes.oneOfType([
                        PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        PropTypes.shape({
                            count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                            color: PropTypes.string,
                        }),
                    ]),
                    right: PropTypes.oneOfType([
                        PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        PropTypes.shape({
                            count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                            color: PropTypes.string,
                        }),
                    ]),
                }),
                disabled: PropTypes.bool,
                locked: PropTypes.bool,
                showNewBanner: PropTypes.bool,
                onClick: PropTypes.func,
            })
        ).isRequired,
    }

    onTabClick = (index) => {
        const { id, activeIndex, activeTab } = this.props

        if (activeIndex !== index) activeTab(id, index)
    }

    render() {
        const { id, tabs, activeIndex, inline, level } = this.props

        return (
            <div className={'general-tabs-wrap'}>
                {_.map(tabs, (tab, index) => (
                    <Tab
                        key={index}
                        tabsId={id}
                        index={index}
                        isActive={activeIndex === index}
                        level={level}
                        title={tab.title}
                        subtitle={tab.subtitle}
                        counter={tab.counter}
                        disabled={tab.disabled}
                        locked={tab.locked}
                        showNewBanner={tab.showNewBanner}
                        overrideOnClick={tab.onClick}
                        inline={inline}
                        onClick={this.onTabClick}
                    />
                ))}
            </div>
        )
    }
}
